import { format, isValid, parse } from 'date-fns';
import {
  DATE_API_FORMAT,
  DATETIME_API_FORMAT,
  TIME_API_FORMAT,
} from '../../../../constants';

// Accepted shapes of the entry error 'default' property. The server sends
// display-like formats (01.07.2026), the pickers work with API formats.
const CANDIDATE_FORMATS: Record<'date' | 'time' | 'datetime', string[]> = {
  date: [DATE_API_FORMAT, 'dd.MM.yyyy', 'dd. MM. yyyy'],
  time: ['HH:mm:ss', 'HH:mm'],
  datetime: [
    "yyyy-MM-dd'T'HH:mm:ss",
    'dd.MM.yyyy HH:mm',
    'dd. MM. yyyy HH:mm',
  ],
};

const API_FORMATS: Record<'date' | 'time' | 'datetime', string> = {
  date: DATE_API_FORMAT,
  time: TIME_API_FORMAT,
  datetime: DATETIME_API_FORMAT,
};

// Converts the entry error 'default' value into the API-format string the
// date/time pickers expect. Returns '' when missing or in an unknown format
// (the picker then just starts empty). The server may send the default as a
// number for other entry types, so any non-string input is stringified.
export const parseEntryDefaultDate = (
  valueType: 'date' | 'time' | 'datetime',
  defaultValue?: string | number
): string => {
  if (defaultValue === undefined || defaultValue === null || defaultValue === '') {
    return '';
  }

  for (const candidateFormat of CANDIDATE_FORMATS[valueType]) {
    const parsed = parse(String(defaultValue).trim(), candidateFormat, new Date());
    if (isValid(parsed)) {
      return format(parsed, API_FORMATS[valueType]);
    }
  }

  return '';
};
